type AddressFields = {
  streetAddress?: string | null;
  streetAddress2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
};

export const formatAddressDisplay = (address: AddressFields): string => {
  const street =
    address.streetAddress2 && address.streetAddress
      ? `${address.streetAddress}, ${address.streetAddress2}`
      : address.streetAddress;
  const parts = [
    street,
    address.city,
    address.state,
    address.postalCode,
  ].filter(Boolean);
  return parts.join(', ') || 'Address';
};
